import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type {
	ObjectListFlyoutProps,
	ObjectListFlyoutItem,
} from '@atlassian/navigation-common/types';
import type { FlyoutCloseHandlerProp } from '@atlassian/entry-point-flyout';
import parameters, {
	type JiraFavouriteFilter,
} from '../../../controllers/use-starred-items/__generated__/useStarredItemsQuery.graphql';

type EntryPointParams = {
	cloudId: string;
	filter: JiraFavouriteFilter;
	count: number;
};

type EntryPointType = EntryPoint<
	EntryPointComponent<
		Record<string, OperationType>,
		Record<string, never>,
		ObjectListFlyoutProps<ObjectListFlyoutItem<{}>> & FlyoutCloseHandlerProp,
		Record<string, never>
	>,
	EntryPointParams
>;

export const starredFlyoutEntrypoint: EntryPointType = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-object-list-flyout-entrypoint" */ '@atlassian/global-side-navigation/flyout-menu-item-content'
			),
		{ moduleId: 'objectListFlyoutEntrypoint' },
	),
	getPreloadProps: ({ cloudId, filter, count }: EntryPointParams) => ({
		queries: {
			starredMenuData: {
				parameters,
				options: { fetchPolicy: 'store-and-network' as const },
				variables: { cloudId, count, filter },
			},
		},
	}),
});
